import { Controller } from "@hotwired/stimulus"

// Filters a sub-location <select> based on the currently-selected class
// template. Some templates are locked to specific rooms (the "allowed
// sub-locations" whitelist on ClassTemplate); for those, options not in
// the whitelist are disabled and visually hidden. Templates with no
// restriction show all options (the default).
//
// Wiring:
//   data-controller="template-sub-location-filter"
//
//   data-template-sub-location-filter-restrictions-value (JSON):
//     { "<template_id>": [sub_location_id, ...], ... }
//     Templates absent from this map are treated as unrestricted.
//
//   Target the template <select> with data-template-sub-location-filter-target="template"
//   Target the sub_location <select> with data-template-sub-location-filter-target="subLocation"
//   On the template <select>, add data-action="change->template-sub-location-filter#apply"
export default class extends Controller {
  static targets = [ "template", "subLocation" ]
  static values  = { restrictions: Object }

  declare readonly templateTarget: HTMLSelectElement
  declare readonly subLocationTarget: HTMLSelectElement
  declare readonly restrictionsValue: Record<string, number[]>

  connect() {
    this.apply()
  }

  apply() {
    const templateId = this.templateTarget.value
    const allowed   = this.restrictionsValue[templateId]
    const select    = this.subLocationTarget

    Array.from(select.options).forEach((opt) => {
      if (!opt.value) return // leave the prompt option alone
      // If the template is unrestricted (no entry in the map), show all.
      // Otherwise hide options not in the whitelist.
      const show = !allowed || allowed.includes(Number(opt.value))
      opt.hidden   = !show
      opt.disabled = !show
    })

    // If the current selection is no longer allowed, clear it so the
    // form doesn't submit a stale (and now-hidden) value.
    const currentOpt = select.selectedOptions[0]
    if (currentOpt && currentOpt.disabled) {
      select.value = ""
    }
  }
}
